// extracted by mini-css-extract-plugin
export default {"container":"Komis_container__Yckf7"};